import { FC } from "react";
import { useSelector } from "react-redux";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { selectIsManagedByShopify } from "store/entities/integrations";
import { selectManagedByPartner } from "store/entities/license";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  limitExceededBy: number;
}

export const SeatsExceededMessage: FC<IProps> = ({ limitExceededBy }) => {
  const isHandledByShopify = useSelector(selectIsManagedByShopify);
  const isHandledByPartner = useSelector(selectManagedByPartner);

  return (
    <Text customColor={withVar(DesignToken.ContentBasicSecondary)} data-testid="seats-exceeded">
      {isHandledByPartner && (
        <>
          <b>Your subscription is handled by a Partner.</b> Ask your Partner for any changes to your HelpDesk
          subscription.
        </>
      )}
      {isHandledByShopify && (
        <>
          <b>Your subscription is handled by Shopify.</b> You need to continue on Shopify to extend your subscription.
        </>
      )}
      {!isHandledByPartner && !isHandledByShopify && (
        <>
          You&apos;ll now be charged a prorated amount for{" "}
          <b>
            {limitExceededBy} additional {plural(limitExceededBy, "agent", "agents")}.
          </b>
        </>
      )}
    </Text>
  );
};
